import styled, { css } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScWelcomeOfferCard = styled.div<{ withDescription?: boolean }>`
  display: flex;
  padding: 24px 24px 40px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  border-radius: 20px;
  background: linear-gradient(341deg, #3f005c -10.86%, #a41a8b 95.6%);
  text-align: center;

  &.fr-CA {
    padding-inline: 20px;
  }

  @media (${device.mobile}) {
    gap: 24px;
  }

  ${({ withDescription }) =>
    withDescription &&
    css`
      padding: 24px;
      gap: 0px;
      @media (${device.mobile}) {
        padding-bottom: 28px;
        gap: 0px;
      }
    `}

  & > .header {
    & .title,
    & .description {
      ${typography.headline3}
      text-transform: uppercase;
    }

    & .title {
      line-height: 18px;
    }

    & .description {
      margin: 10px 0;
    }

    & .offer-img {
      height: 94px;
      object-fit: contain;
      @media (${device.mobile}) {
        width: 360px;
        height: 98px;
        object-fit: contain;
        margin-top: -4px;
      }
      ${({ withDescription }) =>
        withDescription &&
        css`
          max-height: 94px;
          object-fit: contain;
          @media (${device.mobile}) {
            height: 94px;
          }
        `}
    }
  }

  & .offer-steps {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;

    & .offer-step {
      border-radius: 12px;
      border: 2px solid #f8a554;
      background: rgba(0, 0, 0, 0.4);
      padding: 6px 14px;

      @media (${device.mobile}) {
        padding: 6px 10px;
      }

      &:nth-child(even) {
        border-color: #8d8d8d;
      }

      &:first-child {
        box-shadow: 0 0 16px 6px rgba(255, 173, 1, 0.6);
      }

      & > .title {
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0;
      }

      & > .description {
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: 0.16px;
        text-transform: uppercase;
      }
    }
  }
`;
